import {Component, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {Lib} from "../libs/Lib";
import {OverlayContainer} from '@angular/cdk/overlay';
import {LocalStoreService} from './services';
import {themeColor} from './common/theme-color';
import {AppService} from "./services";
import {isGalaxy} from "./common";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnDestroy {
    // name = environment.appName;
    // title: string;
    private subscription;
    @HostBinding('class') componentCssClass = 'app-theme-dark';

    constructor(private appService: AppService, private localStoreService: LocalStoreService, public overlayContainer: OverlayContainer) {
        console.log('> DevMode ' + Lib.DevMode());
        console.log('> Galaxy ' + isGalaxy());
        // const zoom = "100%";
        // document.body.style.zoom = zoom;
        // console.log('app zoom ' + zoom);
        // router.events
        //   .filter((event) => event instanceof NavigationEnd)
        //   .map(() => this.route.firstChild)
        //   .filter((childRoute) => childRoute !== null)
        //   .switchMap((childRoute) => childRoute.data)
        //   .filter((data) => !!data)
        //   .subscribe((data: Data) => {
        //     this.title = data.title;
        //   });
        this.subscription = this.localStoreService.theme.subscribe((val) => {
            const theme = this.localStoreService.getStorageValConfig('theme');
            this.convertTheme(theme);
        });
    }

    convertTheme(theme) {
        // convert angular material theme
        let colors;

        // Remove all theme classes first
        document.body.classList.remove('app-theme-dark', 'app-theme-light', 'app-theme-gradient');

        if (theme == '1') {
            document.body.classList.add('app-theme-light');
            this.componentCssClass = 'app-theme-light';
            colors = themeColor['app-theme-light'];
        } else if (theme == '2') {
            document.body.classList.add('app-theme-gradient');
            this.componentCssClass = 'app-theme-gradient';
            colors = themeColor['app-theme-gradient'];
        } else {
            document.body.classList.add('app-theme-dark');
            this.componentCssClass = 'app-theme-dark';
            colors = themeColor['app-theme-dark'];
        }

        // convert custom colors
        Object.keys(colors).forEach(property =>
            document.documentElement.style.setProperty(property, colors[property])
        );
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }

    }
}
